import { Injectable, Type } from '@angular/core';
import { AppDialogParam } from './app-dialog';
import { AppDialogGateway } from './app-dialog.gateway';
import { AppDialogRef } from './app-dialog-reference';

@Injectable({
  providedIn: 'root'
})
export class AppDialogService {
  /**
   * Constructor
   * @param gateway gateway de confirmación
   */
  constructor(private readonly gateway: AppDialogGateway) {}

  /**
   * Muestra un modal con el componente indicado
   * @param {Type<unknown>} component componente a mostrar
   * @param {AppDialogParam} [params] parámetros del diálogo
   * @returns {AppDialogRef} referencia al diálogo
   */
  show(component: Type<unknown>, params?: AppDialogParam): AppDialogRef {
    return this.gateway.show(component, params);
  }

  /**
   * Devuelve la referencia al diálogo
   * @returns {AppDialogRef} referencia al diálogo
   */
  getRef(): AppDialogRef {
    return this.gateway.getRef();
  }

  /**
   * Devuelve los parámetros del diálogo
   * @returns {AppDialogParam} parámetros del diálogo
   */
  getParams(): AppDialogParam {
    return this.gateway.getParams();
  }
}
